import { LS_CART_KEY } from '../data';
export function loadLocalCart() {
    var _a;
    try {
        const data = JSON.parse((_a = localStorage.getItem(LS_CART_KEY)) !== null && _a !== void 0 ? _a : '[]');
        return Array.isArray(data) ? data : [];
    }
    catch (e) {
        console.error(e);
        return [];
    }
}
export function getFlangeNameForFrameXls(theFlange) {
    const flangesObj = {
        '---': '',
        "<h3><img src='/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png' class='scale' alt='12-2-1' />оц.ш20/у65</h3>": '20',
        "<h3><img src='/wp-content/themes/mesmerize-child/assets/img/Прямоугольный/12-2-1.png' class='scale' alt='12-2-1' />оц.ш30/у105</h3>": '30',
        'Сетка 5x5': 'С5х5',
        'Отбортовка 30': 'ОТБ-30',
        'Ниппель': 'НП',
        'ФЛ': 'ФЛ',
        'Прямошовный': 'ПШ',
        'Заглушка': 'ЗГ',
        'Спирально-навивной': 'СН',
    };
    if (theFlange in flangesObj) {
        return flangesObj[theFlange];
    }
    return theFlange;
}
